import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import Cookies from 'js-cookie';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Navigate, useLocation, useSearchParams } from 'react-router-dom';
export const ProtectedRoutes = (param)=>{
    let { children, condition } = param;
    var _Cookies_get_trim, _Cookies_get, _Cookies_get_trim1, _Cookies_get1;
    const isAuthenticated = Boolean((_Cookies_get = Cookies.get('access')) === null || _Cookies_get === void 0 ? void 0 : (_Cookies_get_trim = _Cookies_get.trim()) === null || _Cookies_get_trim === void 0 ? void 0 : _Cookies_get_trim.length) && Boolean((_Cookies_get1 = Cookies.get('refresh')) === null || _Cookies_get1 === void 0 ? void 0 : (_Cookies_get_trim1 = _Cookies_get1.trim()) === null || _Cookies_get_trim1 === void 0 ? void 0 : _Cookies_get_trim1.length);
    const { i18n } = useTranslation('common');
    const [searchParams] = useSearchParams();
    const query = searchParams.get('redirect');
    const location = useLocation();
    if (!isAuthenticated && !location.pathname.includes('trade-platform')) {
        Cookies.remove('access');
        Cookies.remove('access.sig');
        Cookies.remove('refresh');
        Cookies.remove('refresh.sig');
        localStorage.removeItem('videoCallOrderId');
        localStorage.removeItem('videoCallType');
        localStorage.removeItem('promoCodeApi');
        localStorage.removeItem('isModalShowed');
        localStorage.removeItem('selectedCif');
        localStorage.removeItem('phoneNumber');
        localStorage.removeItem('asanId');
        localStorage.removeItem('verificationNumber');
        localStorage.removeItem('sessionIdForAsan');
        localStorage.removeItem('asan-mobile-number');
        localStorage.removeItem('loyalty');
        sessionStorage.clear();
        const redirectPath = query ? query : `/digital-platform/${i18n.language}`;
        window.location.href = redirectPath;
        return null;
    }
    if (condition !== undefined && !condition) {
        return /*#__PURE__*/ _jsx(Navigate, {
            to: "/dashboard",
            replace: true
        });
    }
    return /*#__PURE__*/ _jsx(_Fragment, {
        children: children
    });
};
